var _defs, _path, _polygon, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaskReserved24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#009AD9;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TaskReserved_24") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,21a6,6,0,1,1,6-6A6,6,0,0,1,12,21Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,12,11Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "13 14 13 12 11 12 11 16 13 16 15 16 15 14 13 14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.35,7a7.49,7.49,0,0,0-14-2A6,6,0,0,0,4.19,16.71,8,8,0,0,1,4,15c0-.18,0-.36,0-.54A4,4,0,0,1,6,7h.71A5.5,5.5,0,0,1,17.5,8.5V9H19a3,3,0,0,1,1,5.82c0,.06,0,.12,0,.18a8.08,8.08,0,0,1-.24,1.92A5,5,0,0,0,19.35,7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskReserved24);
export default __webpack_public_path__ + "static/media/TaskReserved_24.88fabcfb24665d4b1b7ba2fd5e641f35.svg";
export { ForwardRef as ReactComponent };